import { css } from '@emotion/core'

export const Overrides = css`
  .date-picker-popper {
    z-index: 5;
  }
`
